module.exports = __webpack_public_path__ + "static/media/lima.87028e53.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/lima.png
// module id = 97
// module chunks = 0